Alerts = require 'views/lib/alerts'
ApiError = require 'network/api-error'
ApiPromise = undefined
queueRequire -> ApiPromise = require 'network/api-promise'
Auth = require 'db/auth'
PopOver = require 'views/lib/pop-over'
React = require 'react'
localizeServerError = require 'lib/localize-server-error'
t = require('views/internal/recup-with-helpers')('manage_members')
track = require 'debug/track'
_ = require 'underscore'
InvitationLink = require './invitation-link'
InviteAddName = require './invite-add-name'
MemberList = require './member-list'
Summary = require './summary'

DEBOUNCE_DELAY = 250 #ms
debounce = (fn) -> _.debounce(fn, DEBOUNCE_DELAY)
EMAIL_REGEX = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/

module.exports = class extends React.Component
  displayName: 'ManageOrgMembersComponent'

  constructor: (props) ->
    super(props)

    @state = {
      isSearching: false
      members: null
      searchValue: null
      selectedMembers: []
    }

  render: t.renderable ->
    { isSearching, members, searchValue, selectedMembers } = @state

    searchClass = if isSearching then '' else '.hide'
    isEmail = searchValue && EMAIL_REGEX.test(searchValue) && Auth.me().attributes.email != searchValue

    t.div '.add-member-popup', =>
      t.div '.search-with-spinner', =>
        t.input '.search-member', { type: 'text', onChange: @onSearchInputChange }
        t.div ".spinner.small#{searchClass}"
      if !members
        t.div '.quiet.search-text', -> t.format 'search-for-a-person-in-trello-by-name-or-email-address-or-enter-an-email-address-to-invite-someone-new'
        @renderInvitationLink()
      else if !members.length
        if isEmail
          @renderInviteAddName()
          @renderInvitationLink()
        else
          t.div '.quiet.search-text.no-results', -> t.format 'no-results'
      else
        @renderMemberList()
        if selectedMembers.length
          @renderSummary()


  ############################################################################################################
  ############################################################################################################
  ############################################################################################################

  renderMemberList: =>
    { members, selectedMembers } = @state

    t.createElement MemberList, { members, selectedMembers, @toggleMember }

  renderInvitationLink: =>
    { model } = @props

    t.createElement InvitationLink, { apiUrl: model.url(), teamUrl: model.get('url') }

  renderInviteAddName: =>
    { model, modelCache } = @props
    { searchValue } = @state

    email = searchValue

    t.createElement InviteAddName, { email, model, modelCache }

  renderSummary: =>
    { selectedMembers } = @state
    { model } = @props

    selectedMembersCount = selectedMembers.length
    price = model.calculateTotalPrice selectedMembersCount

    if model.isPremiumMonthly()
      subscriptionIntervalKey = 'monthly-subscription'
    if model.isPremiumYearly()
      subscriptionIntervalKey = 'yearly-subscription'

    salesTaxForSubscriberUrl = "#{model.urlRoot}/#{model.id}/paidAccount/salesTaxForSubscriber"

    t.createElement Summary, { @addSelectedMembers, price, salesTaxForSubscriberUrl, selectedMembersCount, subscriptionIntervalKey }

  toggleMember: (idMember) =>
    if @state.selectedMembers.some((id) -> id == idMember)
      selectedMembers = @state.selectedMembers.filter((id) -> id != idMember)
    else
      selectedMembers = [@state.selectedMembers..., idMember]

    @setState { selectedMembers }

  onSearchInputChange: ({ target: { value } }) =>
    @setState selectedMembers: []

    if !value.length
      @setState({ members: null, searchValue: null })
    else
      @searchMembers value

  searchMembers: debounce (searchValue) ->
    searchValue = searchValue.toLowerCase().trim()

    @setState {
      isSearching: true
      searchValue
    }

    ApiPromise
      url: '/1/search/members/'
      type: 'get'
      data:
        idOrganization: @props.model.id
        query: searchValue
      dataType: 'json'
    .then (members) =>
      members = _.sortBy members.filter((m) -> m.active), (member) -> member.fullName?.toLocaleLowerCase()

      @setState {
        isSearching: false
        members
      }

  addSelectedMembers: =>
    { members, selectedMembers } = @state
    { model } = @props

    selectedMembers.forEach (idMember) =>
      member = members.filter((m) -> m.id == idMember)[0]
      model.addMember(member)
           .catch ApiError, @_handleError

    PopOver.hide()

  _handleError: (resOrApiError) =>
    message = localizeServerError(resOrApiError)

    Alerts.showLiteralText(message, 'error', 'alert', 3000)
    track("Invitations", "Error: #{ resOrApiError.message ? resOrApiError.responseText }")



// WEBPACK FOOTER //
// ./app/scripts/views/organization/manage-org-members-component/index.coffee